import script from "./ClientProjectDeailAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectDeailAdd.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectDeailAdd.vue?vue&type=style&index=0&id=805a7bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-805a7bc2"]])

export default __exports__